import { AccountResponse } from '../api/getAccounts';

export interface AccountView {
  id: number;
  type: 'company' | 'project';
  name: string;
  managerId: number | null;
  managerName: string;
  managerAvatarUrl: string | null;
  email: string;
  active: boolean;
  /** BE-computed: may the viewer change this account's status. Default-deny. */
  canManage: boolean;
}

// The backend returns the lead's raw avatar filename (or 'default.png' / null when
// none is set). Build the served image URL the same way the rest of the app does.
const avatarUrl = (file: string | null | undefined): string | null =>
  file && file !== 'default.png' ? `/api/file/profile_pictures/${file}` : null;

export const mapAccount = (a: AccountResponse): AccountView => ({
  id: a.id,
  type: a.type,
  name: a.name,
  managerId: a.manager?.id ?? null,
  managerName: a.manager?.['full-name'] ?? '',
  managerAvatarUrl: avatarUrl(a.manager?.avatar),
  email: a['inbox-email'] ?? '',
  active: a['is-active'],
  // Default-deny: a response cached from before this field shipped has no 'can-manage',
  // and an undefined would render the manage affordance for everyone.
  canManage: a['can-manage'] ?? false,
});
